import React from "react";
import { styled } from "styled-components";
import { Color } from "../../theme/Color";
import { useSelector } from "react-redux";
import { CardContent, CardTitle, Description, Section112, SubTitle, TitleSection } from "../DesignComponent/DesignComponents";

const F3_5 = () => {
  const data = useSelector(
    (state) => state?.landingPage?.data?.acf?.why_the_leansuite
  );

  const CardIcon = styled.img`
    width: 64px;
    height: 64px;
    border: 1px solid ${Color.lightwhite};
  `;
  const CardDiv = styled.div`
    background-color: #8394F612 !important;
    padding: 5px 15px;
  `;

  const IconBoxesCards = ({ data, iconKey }) => (
    <CardDiv className="card border-0 text-center mb-3 h-100 mx-0 bg-transparent text-white">
      <CardIcon
        src={data?.icon_boxes?.[iconKey]?.icon}
        alt={data?.icon_boxes?.[iconKey]?.icon_box_title}
        className="mb-3  rounded-circle p-2"
      />
      <div className="card-body p-0">
        <CardTitle className="card-title text-start">
          {data?.icon_boxes?.[iconKey]?.icon_box_title}
        </CardTitle>
        <CardContent className="card-text text-start" style={{ color: Color.lightwhite }}>
          {data?.icon_boxes?.[iconKey]?.icon_box_description}
        </CardContent>
      </div>
    </CardDiv>
  );

  return (
    <>
      <Section112 className="why_leansuit text-center text-white" style={{ backgroundColor: Color.theme_first }}>
        <div className="container">
          <div className="row mb-3 pb-md-3 justify-content-center">
            <div className="col-lg-8 col-md-6 col-sm-8">
              <SubTitle
                className="sub-title mb-2"
              >
                {data?.text_before_title}
              </SubTitle>
              <TitleSection className="mb-3">{data?.title}</TitleSection>
              <Description
                className="description mb-4"
                style={{ color: Color.lightwhite }}
              >
                {data?.description}
              </Description>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-7 col-sm-7">
              <IconBoxesCards data={data} loading="lazy" iconKey="gain_efficiency_faster" />
            </div>
            <div className="col-lg-4 col-md-7 col-sm-7">
              <IconBoxesCards data={data} loading="lazy" iconKey="be_more_proactive" />
            </div>
            <div className="col-lg-4 col-md-7 col-sm-7">
              <IconBoxesCards data={data} loading="lazy" iconKey="everything_in_one_place" />
            </div>
          </div>
        </div>
      </Section112>
    </>
  );
};

export default F3_5;
